import { Switch } from "@heroui/react";

export default function ShowAAsFilter({
  selected,
  setSelected,
}: {
  selected: boolean;
  setSelected: any;
}) {
  return (
    <div>
      <Switch size="sm" isSelected={selected} onValueChange={setSelected}>
        Show AAs
      </Switch>
      {/* {selected.valueOf()} */}
    </div>
  );
}
